import { get, patch } from "utils/FetchAPI";

export const getNotifications = () => get('/notifications',{limit:10})

export const readedNotification = (data) => patch('/notifications', data)